import { Sidebar } from "primereact/sidebar";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router";

import { cn } from "@/styles/cn";
import { Button, CenterLayout } from "@/components";
import { InputTextField } from "@/components/organisms/Form";
import { PathNamekAppsRoutes, PathNamekRoutes } from "@/router";

import { useMaterialForm } from "./MaterialForm.hook";

export function MaterialEditor() {
  const { edition } = useParams();
  const navigate = useNavigate();
  const id = isNaN(Number(edition)) ? 0 : Number(edition);

  const closeForm = () => {
    navigate(`/${PathNamekAppsRoutes.CONFIG}/${PathNamekRoutes.CONFIG.MATERIALS}`, {
      replace: true,
    });
  };

  const { form, onSubmit, isSubmitDisabled, isSubmiting, isNew, isFetching } = useMaterialForm({
    id,
    onDone: closeForm,
  });

  const headerTitle = isNew ? "Nuevo material" : "Editar material";
  const submitLabel = isNew ? "Crear" : "Guardar";

  return (
    <Sidebar
      className="w-full bg-white px-[1.375rem] py-[1.5rem] min-[400px]:w-[360px]"
      dismissable={false}
      header={headerTitle}
      position="right"
      pt={{
        header: {
          className: cn("text-urbe-primary text-lg font-bold mb-8"),
        },
        mask: {
          className: cn(
            "flex pointer-events-auto",
            "bg-black bg-opacity-40 transition duration-200 z-20 transition-colors",
          ),
        },
      }}
      visible={true}
      onHide={closeForm}
    >
      {isFetching && <CenterLayout>Cargando...</CenterLayout>}
      {!isFetching && (
        <FormProvider {...form}>
          <form className="flex h-full flex-col gap-5" onSubmit={form.handleSubmit(onSubmit)}>
            <div className="flex h-full flex-1 flex-col gap-5 overflow-auto p-1">
              <InputTextField autoFocus required label="Nombre" name="name" />
            </div>
            <footer className="flex flex-row justify-end gap-5">
              <Button severity="secondary" type="button" onClick={closeForm}>
                Cancelar
              </Button>
              <Button
                disabled={isSubmitDisabled}
                label={submitLabel}
                loading={isSubmiting}
                type="submit"
              />
            </footer>
          </form>
        </FormProvider>
      )}
    </Sidebar>
  );
}
